var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIc2HPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1048",
    "data-name": "Rectangle 1048",
    width: 36,
    height: 36,
    transform: "translate(-0.333 -0.333)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_2_h_plus",
    transform: "translate(-328.833 -215.421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(328.833 215.421)",
    fill: "rgba(195,230,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297",
    transform: "translate(336.414 223.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(-0.249 -0.249)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21748",
    "data-name": "Path 21748",
    d: "M16.259,31.974A15.715,15.715,0,1,1,31.976,16.257,15.734,15.734,0,0,1,16.259,31.974",
    transform: "translate(1.408 1.411)",
    fill: "#ffcc54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21749",
    "data-name": "Path 21749",
    d: "M2.663,18.38A15.7,15.7,0,0,1,28.3,6.2,15.706,15.706,0,1,0,6.2,28.3,15.633,15.633,0,0,1,2.663,18.38",
    transform: "translate(1.11 1.11)",
    fill: "#ffe8b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21750",
    "data-name": "Path 21750",
    d: "M15.32,7.282a.854.854,0,0,0-1.164.318,9.576,9.576,0,0,1-8.309,4.834.854.854,0,0,0,0,1.709,11.292,11.292,0,0,0,9.791-5.7.854.854,0,0,0-.318-1.164",
    transform: "translate(10.968 15.641)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21751",
    "data-name": "Path 21751",
    d: "M17.423,0A17.423,17.423,0,1,0,34.845,17.423,17.443,17.443,0,0,0,17.423,0m0,33.14A15.715,15.715,0,1,1,33.14,17.423,15.734,15.734,0,0,1,17.423,33.14",
    transform: "translate(0.245 0.245)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21752",
    "data-name": "Path 21752",
    d: "M21.749,2.777H7.483a6.173,6.173,0,1,0,5.945,7.818l.1-.076v-.312a1.143,1.143,0,0,1,2.206.123l.047.2.013.016a6.169,6.169,0,1,0,5.954-7.764m0,10.641A4.472,4.472,0,0,1,17.39,9.9l-.009-.028a2.85,2.85,0,0,0-5.438-.29l-.1.334A4.465,4.465,0,1,1,7.483,4.483H21.749a4.467,4.467,0,1,1,0,8.935",
    transform: "translate(3.053 6.207)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21753",
    "data-name": "Path 21753",
    d: "M20.585,12.254a4.472,4.472,0,0,1-4.359-3.522L16.217,8.7a2.85,2.85,0,0,0-5.438-.29l-.1.334A4.465,4.465,0,1,1,6.319,3.319H20.585a4.467,4.467,0,1,1,0,8.935",
    transform: "translate(4.217 7.371)",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21754",
    "data-name": "Path 21754",
    d: "M2.756,8.693A4.473,4.473,0,0,1,7.222,4.224H21.491a4.438,4.438,0,0,1,2.666.894,4.461,4.461,0,0,0-3.575-1.8H6.316A4.463,4.463,0,0,0,3.65,11.362a4.427,4.427,0,0,1-.894-2.669",
    transform: "translate(4.217 7.369)",
    fill: "#737373"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc2HPlus);
export default __webpack_public_path__ + "static/media/ic_2_h_plus.3485892953f181cdd6ebd1b1d46c5a57.svg";
export { ForwardRef as ReactComponent };